export default function InputField({
  label,
  required,
  value,
  onChange,
  type = "text",
  placeholder,
  error,
  disabled = false 
}) {
  const errorStyle = error
    ? 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500'
    : 'border border-gray-300 focus:ring-blue-500 focus:border-blue-500';

  const textStyle = disabled
    ? 'text-gray-400 cursor-not-allowed'
    : 'text-gray-900';

  const labelStyle = disabled
    ? 'text-gray-400 cursor-not-allowed'
    : error
    ? 'text-red-700'
    : 'text-gray-900';

  return (
    <div className="mb-6">
      <label className={`block text-sm font-medium mb-1 ${labelStyle}`}>
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        disabled ={disabled}
        className={`w-full px-3 py-2 bg-gray-50 rounded-lg shadow-sm focus:outline-none ${errorStyle} ${textStyle}`}       
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}
